import React from "react";
import Alert from "react-bootstrap/Alert";
import {Form} from "react-bootstrap";
import avatarImage from '../../assets/images/faces-clipart/pic-2.png';
import {bookingServiceNode} from "../_redux/services/nodeserver/bookingServiceNode";
import "./style.css";
import {formatDatetimeISO, formatDateYMD, MyDatePicker} from "../_helpers/HNTDate";
import {getCustomerBook, setCustomerBook} from "../_helpers/HNTUtil";
import {appRoutePath} from "../_helpers/AppConts";
import {Redirect} from "react-router";


const steps = {
    selectService: {
        value: 'select_service',
        label: 'Select Services'
    },
    selectStaff: {
        value: 'select_staff',
        label: 'Select Staffs'
    },
    selectDatetime: {
        value: 'select_datetime',
        label: 'Select Date & Time'
    },
    customerInfo: {
        value: 'enter_info',
        label: 'Enter Your Infomation'
    }
}


function getUrlParameters(name = '', decode = false){
    const queryParams = window.location.search.substr(1).split('&').reduce((obj, keyVal) => {
        const [key, value] = keyVal.split('=');
        obj[key] = decode ? decodeURIComponent(value.replace(/\+/g, ' ')) : value;
        return obj;
    }, {});

    return queryParams[name]
}


function refreshPage(e){
    if (window.location) {
        window.location.reload();
    }
}

var currentTab = 0; // Current tab is set to be the first tab (0)

class AppointmentBook extends React.Component {
    constructor(props) {
        super(props);

        let dataId = getUrlParameters('sid', false);
        let _storeId = parseInt(dataId, 10);

        let _customer = {name: '', phone: '', note: ''};
        let _customerBook = getCustomerBook();
        if (_customerBook) {
            _customer.name = _customerBook.name || '';
            _customer.phone = _customerBook.phone || '';
            _customer.note = _customerBook.note || '';
        }

        this.state = {
            //Step screen
            currentStep: steps.selectService,

            //Data input || select
            storeId: _storeId,
            staff: '', /** Staff Name */
            service: [],
            date: new Date(),
            time: '09:30',
            name: _customer.name,
            phone: _customer.phone,
            note: _customer.note,

            //Data source
            servicesDS: [],
            staffsDS: [],
            store: {},

            error: null,
            result: null,
            submited: true
        }
    }

    componentDidMount() {
        this.loadStore();
    }

    loadStaffs = () => {
        bookingServiceNode.getStaffs(this.state.storeId)
            .then(
                result => {
                    this.setState({
                        error: null,
                        staffsDS: result.content,
                        submited: false
                    });

                    /** Tab Staff */
                    this.nextPrev(0);
                },
                err => {
                    this.setState({
                        error: err,
                        submited: false
                    })
                }
            );
    }


    /**
     * Load Service in Staff
     * @param staffId
     */
    loadServicesInStaff = (staffId) => {
        bookingServiceNode.getServicesInStaff(this.state.storeId, staffId)
            .then(
                result => {
                    this.setState({
                        error: null,
                        servicesDS: result.content,
                        submited: false
                    });

                    /** Tab Service in Staff*/
                    this.nextPrev(1);
                },
                err => {
                    this.setState({
                        error: err,
                        submited: false
                    })
                }
            );
    }

    loadStore = () => {
        bookingServiceNode.getStore(this.state.storeId)
            .then(
                store => {
                    this.setState({
                        store: store,
                        error: null
                    });
                    this.loadStaffs();
                },
                err => {
                    console.log(JSON.stringify(err))
                    if (err.status == 404) {
                        this.setState({
                            redirect: appRoutePath.Error404
                        })
                    } else {
                        this.setState({
                            error: err,
                            submited: false
                        })
                    }
                }
            )
    }

    onChangeDate = (date) => {
        this.setState({
            date: date
        })
    }

    onChangeText = (e) => {
        const {name, value} = e.target;
        this.setState({
            [name]: value
        });
    }

    onClickBooking = (e) => {
        let {name, value} = e.target;
        let staffString = e.target.getAttribute('data-staff');
        if (staffString) {
            let staff = JSON.parse(staffString);
            if (staff && staff.id) {
                this.setState({
                    staff: staff.name,
                    submited: true
                });
                this.loadServicesInStaff(staff.id);
            }
        }

        e.preventDefault();
    }

    onChangeService = (e) => {
        let target = e.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        let id = parseInt(target.getAttribute('data-id'), 10);
        let name = target.getAttribute('data-name');

        let servieArr = this.state.service;
        if (value) {
            servieArr = this.state.service.concat([{id: id, name: name}]);
        } else {
            for (var i = servieArr.length - 1; i >= 0; i--) {
                if (servieArr[i].id === id) {
                    servieArr.splice(i, 1);
                }
            }
        }

        this.setState({
            service: servieArr
        });

        this.showNextBtn(servieArr.length > 0);
    }


    createDatetimeISO = () => {
        let datetimeBookedString = formatDateYMD(this.state.date) + 'T' + this.state.time + ':00';
        let gmtInt = this.state.store.gmt, datetimeISOString = '';

        if (gmtInt > 0) {
            datetimeISOString = datetimeBookedString + '+' + (gmtInt).toString().padStart(2, '0') + ':00';
        }
        else if (gmtInt < 0)  {
            datetimeISOString = datetimeBookedString + '-' + (Math.abs(gmtInt)).toString().padStart(2, '0') + ':00';
        }
        else {
            datetimeISOString = datetimeBookedString + 'Z';
        }
        return new Date(datetimeISOString).toISOString();
    }


    onSubmited = (e) => {
        e.preventDefault();
        let state = this.state;

        let service = state.service.reduce((name, value, index) => {
            if (index === 0) {
                return value.name;
            } else {
                return name + ', ' + value.name;
            }
        }, '');

        let data = {
            store_id: state.storeId,
            staff: state.staff, /** Staff Name */
            service: service,
            book_date: formatDateYMD(this.state.date),
            book_dt: this.createDatetimeISO(),
            gmt: state.store.gmt,
            name: state.name,
            phone_number: state.phone,
            note: state.note
        }

        if (!this.validateForm()) {
            return;
        }

        if (!data.store_id || !data.name || !data.phone_number) {
            let err = new Error('Please select infomation requred');
            return this.setState({
                error: err,
            });
        }


        bookingServiceNode.create(state.storeId, data)
            .then(
                result => {
                    setCustomerBook({
                        name: data.name,
                        phone: data.phone_number,
                        note: data.note
                    });

                    this.onCreateSuccessfuly(result);
                },
                err => {
                    this.setState({
                        error: err,
                        submited: false
                    })
                }
            );
    }


    onCreateSuccessfuly = (result) => {
        this.setState({
            result: result,
            staff: '',
            service: [],
            date: new Date(),
            time: '09:30',
            name: '',
            phone: '',
            note: '',

            error: null,
            submited: false
        })
    }


    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={this.state.redirect}/>
            )
        }

        if (!this.state.storeId) {
            return (
                <div className='form-panel'>
                    <Alert variant='danger'>Store infomation not found. Please refresh page to try again</Alert>
                </div>
            );
        }

        if (!this.state.error && currentTab === 3) {
            if (this.state.result) {
                return (
                    <div className='form-panel'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='store'>
                                    <div className='store-name'>
                                        <span>{this.state.store && this.state.store.name}</span>
                                    </div>
                                    <div className='store-phone'>
                                        <span>Phone: {this.state.store && this.state.store.phone_number}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='row justify-content-center'>
                            <div className='col-xs-10 col-md-12 col-lg-8'>
                                {this.Successful()}
                            </div>
                        </div>
                    </div>
                );
            }
        }

        return (
            <div className='form-panel'>
                {this.state.error && <Alert variant='danger'>{this.state.error.message}</Alert>}
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='store'>
                            <div className='store-name'>
                                <span>{this.state.store && this.state.store.name}</span>
                            </div>
                            <div className='store-phone'>
                                <span>Phone: {this.state.store && this.state.store.phone_number}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row justify-content-center'>
                    <div className='col-md-12 col-lg-8'>
                        <form id="regForm" onSubmit={this.onSubmited}>
                            <div className='step-container'>
                                <span className="step"></span>
                                <span className="step"></span>
                                <span className="step"></span>
                                <span className="step"></span>
                            </div>

                            <h1>{this.state.currentStep.label}</h1>

                            <div className="tab-container">
                                {/*Staff*/}
                                <div className="tab">
                                    {this.StaffTab()}
                                </div>

                                {/*Services*/}
                                <div className="tab">
                                    {this.ServiceTab()}
                                </div>

                                {/*Date & Time*/}
                                <div className="tab">
                                    {this.DateTimeTab()}
                                </div>

                                {/*Your info*/}
                                <div className="tab">
                                    {this.CustomerInfoTab()}
                                </div>
                            </div>

                            <button type='submit' hidden={true} id="submit"/>
                        </form>
                    </div>
                </div>
                <div className='nav-bottom'>
                    <div className='nav-bottom-row'>
                        <button type="button" className="btn btn-secondary" id="prevBtn" onClick={() => this.nextPrev(-1)}>Previous</button>
                        <button type="button" className="btn btn-primary" id="nextBtn" onClick={() => this.nextPrev(1)}>Next</button>
                        <button type='button' className="btn btn-danger" id="submitBtn" onClick={() => this.nextPrev(1)}>Submit</button>
                    </div>
                </div>
            </div>
        );
    }

    StaffTab = () => {
        const staffView = this.state.staffsDS.map((staff, index) => {
            return (
                <div key={index} className="col-md-6">
                    <div className="staff-a-itm clearfix">
                        <div className="staff-avatar">
                            <img className="img-avatar rounded-circle" src={avatarImage} alt="Avatar staff"/>
                        </div>
                        <div className="staff-dt">
                            <h3> {staff.name} </h3>
                            <button data-staff={JSON.stringify(staff)} onClick={this.onClickBooking}>
                                Book with this person
                            </button>
                        </div>
                    </div>
                </div>
            );
        });


        return (
            <div className='card'>
                <div className="card-body">
                    <div className='row'>
                        {staffView}
                        {/*<div className="col-md-6">
                            <div className="staff-a-itm clearfix">
                                <div className="staff-avatar">
                                    <img className="img-avatar rounded-circle" src={avatarImage} alt="Avatar staff"/>
                                </div>
                                <div className="staff-dt">
                                    <h3> Nguyen Thanh Hoa </h3>
                                    <button type="button" data-id={2} data-name={'test2'} className="btn-book-appoitment" onClick={this.onClickBook}>
                                        Book with this person
                                    </button>
                                </div>
                            </div>
                        </div>*/}
                    </div>
                </div>
            </div>
        );
    }

    ServiceTab = () => {
        const servicesView = this.state.servicesDS.map((service, index) => {
            let _nameAndPrice = service.price ? (service.name + ' - $' + service.price) : service.name;
            return (
                <div key={index} className="col-md-6 col-lg-6">
                    <div className="service-category">
                        <div className="service-item" id='service-item'>
                            <div className="form-check">
                                <input className="service-item-checkbox"
                                       type="checkbox" id={"check_" + service.id}
                                       data-id={service.id}
                                       data-name={service.name}
                                       onChange={this.onChangeService}
                                />
                                <label className="service-item-label" htmlFor={"check_" + service.id}>
                                    {_nameAndPrice}
                                    <label className='service-item-description'>
                                        {service.description}
                                    </label>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            );
        });

        return (
            <div className='card'>
                <div className="card-body">
                    <div className='row'>
                        {servicesView}
                        {/*<div className="service-category">
                            <h3 >service category nails</h3>
                            <div className="service-item">
                                <div className="form-check">
                                    <input className="service-item-checkbox" type="checkbox" id="gridCheck1"/>
                                    <label className="service-item-label" htmlFor="gridCheck1">
                                        Example checkbox Example checkbox
                                    </label>
                                </div>

                                <div className="form-check">
                                    <input className="service-item-checkbox" type="checkbox" id="gridCheck1"/>
                                    <label className="service-item-label" htmlFor="gridCheck1">
                                        Example checkbox Example checkbox
                                    </label>
                                </div>

                                <div className="form-check">
                                    <input className="service-item-checkbox" type="checkbox" id="gridCheck1"/>
                                    <label className="service-item-label" htmlFor="gridCheck1">
                                        Example checkbox Example checkbox
                                    </label>
                                </div>

                                <div className="form-check">
                                    <input className="service-item-checkbox" type="checkbox" id="gridCheck1"/>
                                    <label className="service-item-label" htmlFor="gridCheck1">
                                        Example checkbox Example checkbox
                                    </label>
                                </div>
                            </div>
                        </div>*/}
                    </div>
                </div>
            </div>
        );
    }

    DateTimeTab = () => {
        return (
            <div className='card'>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-6 col-lg-6">
                            <Form.Group>
                                <label className="text-black">Select Date</label>
                                <div className="col-sm-5 col-md-6 col-lg-6 p-0">
                                    <MyDatePicker className="form-control-sm col-12"
                                                  name="date"
                                                  selected={this.state.date}
                                                  onChange={this.onChangeDate}/>
                                </div>
                            </Form.Group>
                        </div>
                        <div className="col-md-6 col-lg-6">
                            <Form.Group>
                                <label className="col-sm-5 col-md-6 col-lg-6 p-0 text-black">Select hour work</label>
                                <div>
                                    <select className="form-control-sm col-sm-5 col-md-6 col-lg-6"
                                            name='time'
                                            value={this.state.time}
                                            onChange={this.onChangeText}>
                                        {this.OptionHourBook()}
                                    </select>
                                </div>
                            </Form.Group>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    OptionHourBook = () => {
        let minuteOfDay = 30;
        let timeList = [];
        do {
            let hour = parseInt(minuteOfDay / 60);
            let minute = minuteOfDay % 60;
            minuteOfDay += 30;
            timeList.push({hour: hour, minute: minute, value: minuteOfDay});
        }
        while (minuteOfDay < 60 * 24);

        return timeList.map((e, index) => {
            let valueTime = e.hour.toString().padStart(2, '0') + ':' + e.minute.toString().padStart(2, '0');
            let text;
            if (e.value < 60 * 12) {
                text = e.hour.toString() + ':' + e.minute.toString().padStart(2, '0') + ' AM';
            } else if (e.hour%12 == 0) {
                text = '12:' + e.minute.toString().padStart(2, '0') + ' PM';
            } else {
                text = (e.hour%12).toString() + ':' + e.minute.toString().padStart(2, '0') + ' PM';
            }
            return (
                <option key={index} value={valueTime}>{text}</option>
            );
        });
    }


    CustomerInfoTab = () => {
        return (
            <div className="card">
                <div className="card-body">
                    <h4 className="card-title">How do we say hello?</h4>
                    <p className="card-description">
                        Your name and phone number will be used to send you appointment confirmations and reminders.
                        We’ll also be able to call or text you if anything changes.
                    </p>
                    <Form.Group>
                        <label className="text-black" htmlFor="customer_name">Fullname (*)</label>
                        <input type="text" placeholder="Enter your fullname"
                               id="customer_name"
                               name="name"
                               value={this.state.name}
                               onChange={this.onChangeText}
                        />
                    </Form.Group>
                    <Form.Group>
                        <label className="text-black" htmlFor="customer_phone">Phone Number (*)</label>
                        <input type="text" placeholder="Enter your cellphone"
                               id="customer_phone"
                               name="phone"
                               value={this.state.phone}
                               onChange={this.onChangeText}
                        />
                    </Form.Group>
                    <Form.Group>
                        <label htmlFor="note" className="text-black">Note</label>
                        <input type="text" placeholder="Enter your note"
                               id="note"
                               name="note"
                               value={this.state.note}
                               onChange={this.onChangeText}
                        />
                    </Form.Group>
                </div>
            </div>
        );
    }

    Successful = () => {
        return (
            <div className='form-panel'>
                <div className='succss-panel'>
                    <div className="card">
                        <div className='checkmark'>
                            <i className="checkmark">✓</i>
                        </div>
                        <h1>Success</h1>
                        <p>We received your appointment request;<br/> we'll be in touch shortly!</p>
                        <p className="mt-3">
                            <button className="btn btn-success btn-lg font-weight-bold" onClick={refreshPage}>OK</button>
                        </p>
                    </div>
                </div>
            </div>
        );
    }


    nextPrev = (tabIndex) => {
        const tabs = document.getElementsByClassName("tab");
        if (currentTab >= 0 && currentTab < tabs.length) {
            tabs[currentTab].style.display = "none";
        }

        currentTab = currentTab + tabIndex;
        if (currentTab < 0) {
            currentTab = 0;
        }

        if (currentTab >= tabs.length) {
            currentTab = tabs.length - 1;
            let btnSubmit = document.getElementById("submit");
            if (btnSubmit) {
                btnSubmit.click();
            }
        }

        this.showTab(currentTab);
    }

    showTab = (tabIndex) => {
        let step = null;
        const tabs = document.getElementsByClassName("tab");

        if (tabIndex < 0 || tabIndex >= tabs.length) {
            return;
        }

        tabs[tabIndex].style.display = "block";
        document.getElementById("submitBtn").style.display = "none";
        if (tabIndex === 0) {
            step = steps.selectStaff;
            document.getElementById("prevBtn").style.display = "none";
            document.getElementById("nextBtn").style.display = "none";
        } else if (tabIndex === 1) {
            step = steps.selectService;
            document.getElementById("prevBtn").style.display = "inline";
            document.getElementById("nextBtn").style.display = this.state.service.length > 0 ? "inline" : "none";
        } else if (tabIndex === 2) {
            step = steps.selectDatetime;
            document.getElementById("prevBtn").style.display = "inline";
            document.getElementById("nextBtn").style.display = "inline";
        } else if (tabIndex === 3) {
            step = steps.customerInfo;
            document.getElementById("prevBtn").style.display = "inline";
            document.getElementById("nextBtn").style.display = "none";
            document.getElementById("submitBtn").style.display = "inline";
        } else {
            document.getElementById("prevBtn").style.display = "inline";
        }

        if (step) {
            this.setState({
                currentStep: step
            });
        }
        this.fixStepIndicator(tabIndex);
    }

    fixStepIndicator = (tabIndex) => {
        let x = document.getElementsByClassName("step");
        for (let i = x.length - 1; i >= 0 && i >= tabIndex; i--) {
            x[i].className = x[i].className.replace(" active", "");
        }
        x[tabIndex].className += " active";
    }


    showNextBtn = (show = true) => {
        document.getElementById("nextBtn").style.display = show ? "inline" : "none";
    }

    validateForm = () => {
        let valid = true;
        let tabs = document.getElementsByClassName("tab");
        let inputs = tabs[currentTab].getElementsByTagName("input");

        for (let i = 0; i < inputs.length; i++) {
            if (inputs[i].name !== 'note' && inputs[i].value === '') {
                inputs[i].className += " invalid";
                valid = false;
            }
        }

        if (valid) {
            document.getElementsByClassName("step")[currentTab].className += " finish";
        }

        return valid;
    }
}
export default AppointmentBook;
